import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestPhaseItems, savePhaseItem, deletePhaseItem } from 'actionCreators/phase_items';
import getPurchaseOrderOptions from '../../../../../../../../selectors/purchaseOrderOptions';
import LineItemTable from 'components/LineItemTable';
import WarehouseMerchandiseTableRow from './warehouseMerchandiseTableRow';
import warehouseMerchandiseItem from 'types/warehouseMerchandiseItem';
import { purchaseOrderOptionsType } from 'types/purchaseOrder';

const LINE_ITEM_TYPE = 'warehouseMerchandiseItems';

class WarehouseMerchandiseItemTable extends Component {
  handleDelete = lineItemId => this.props.deletePhaseItem(
    this.props.phaseId, { id: lineItemId }, LINE_ITEM_TYPE);

  handleSave = lineItem => this.props.savePhaseItem(this.props.phaseId, lineItem, LINE_ITEM_TYPE);

  refreshLineItemList = () => this.props.requestPhaseItems(this.props.phaseId, LINE_ITEM_TYPE);

  render = () => (<LineItemTable
    title="Warehouse Merchandise"
    refreshList={this.refreshLineItemList}
    readOnly={!this.props.editable}
    cv={this.props.cv}
  >
    {this.props.lineItems.map(item => <WarehouseMerchandiseTableRow
      padInfo={this.props.padInfo}
      key={item.id}
      onSave={this.handleSave}
      onDelete={this.handleDelete}
      lineItem={item}
      purchaseOrderOptions={this.props.purchaseOrderOptions}
      readOnly={!this.props.editable}
    />)}
  </LineItemTable>);
}

WarehouseMerchandiseItemTable.defaultProps = {
  lineItems: [], editable: true, cv: false,
};

WarehouseMerchandiseItemTable.propTypes = {
  phaseId: PropTypes.string,
  lineItems: PropTypes.arrayOf(PropTypes.shape(warehouseMerchandiseItem)),
  requestPhaseItems: PropTypes.func,
  savePhaseItem: PropTypes.func,
  deletePhaseItem: PropTypes.func,
  purchaseOrderOptions: purchaseOrderOptionsType,
  editable: PropTypes.bool.isRequired,
  padInfo: PropTypes.arrayOf(PropTypes.shape({
    cut_quantity: PropTypes.string, description: PropTypes.string,
  })),
  cv: PropTypes.bool,
};

export default connect(state => ({ purchaseOrderOptions: getPurchaseOrderOptions(state) }), {
  requestPhaseItems, savePhaseItem, deletePhaseItem,
})(WarehouseMerchandiseItemTable);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehouseMerchandiseItemTable.jsx